import React, { Component } from "react";

import moment from "moment";

import api from "../../../api/";
import ParadigmaTable from "../../../components/ParadigmaTable/";
import DateFilter from "../../../components/ParadigmaTable/DateFilter";
import Modal from "./Modal.js";

class Historial extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const columns = [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Código Verificación",
                    id: "codigo_verificacion",
                    accessor: "codigo_verificacion",
                    show: true,
                    lookup: "icontains",
                    filterable: true,
                },
                {
                    Header: "Orden",
                    id: "orden",
                    accessor: "orden",
                    show: true,
                    filterable: true,
                },
                {
                    // Es tambien la columna por la que ordena outerSort
                    Header: "Fecha",
                    id: "pedido_vianda_fecha",
                    accessor: (d) => moment(d.pedido_vianda_fecha).format("DD/MM/YYYY"),
                    width: 120,
                    className: "text-center",
                    show: true,
                    // Sin `lookup`: el DateFilter manda el suyo junto con el
                    // valor (date, date__gt o date__lt segun lo que se elija en
                    // el popover). datetime porque la fecha del pedido guarda
                    // la hora y los lookups tienen que ir contra la fecha sola.
                    Filter: ({ filter, onChange }) =>
                        <DateFilter filter={filter} onChange={onChange} datetime />,
                },
                {
                    Header: "Rol",
                    id: "rol_usuario",
                    accessor: "rol_usuario",
                    show: true,
                    filterable: true,
                },
                {
                    Header: "Menú Diario",
                    id: "menu_diario_codigo",
                    accessor: "menu_diario_codigo",
                    show: true,
                    lookup: "icontains",
                    filterable: true,
                },
                {
                    Header: "Estado",
                    id: "estado_nombre",
                    accessor: "estado_nombre",
                    show: true,
                    filterable: true,
                },
            ];
        let outerSort = [];

        outerSort.push({
            id: 'pedido_vianda_fecha',
            desc: true
        })

        return (
            <ParadigmaTable
                buttons={[
                    {
                        edit: true,
                        component: (props) => (
                            <Modal {...props} action="DETAIL" />
                        ),
                        // Sin permission: son las filas del propio usuario, el
                        // backend ya no devuelve las de nadie mas.
                    },
                ]}
                apiUrl={api.viandas.misPedidosDetalles}
                columns={columns}
                exportUrl={api.viandas.misPedidosDetalles}
                outerSort={outerSort}
                defaultPageSize={21}
                title={"Historial de Viandas"}
            />
        )
    }
}

export default Historial;



// WEBPACK FOOTER //
// ./src/views/Viandas/HistorialViandas/HistorialViandas.js